import { lazy, Suspense, useEffect, useState } from "react";

const BookingDialog = lazy(() =>
  import("./BookingDialog").then((m) => ({ default: m.BookingDialog })),
);

export function BookingDialogLoader() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const handler = () => setMounted(true);
    window.addEventListener("open-booking", handler);
    return () => window.removeEventListener("open-booking", handler);
  }, []);

  if (!mounted) return null;
  return (
    <Suspense fallback={null}>
      <BookingDialog defaultOpen />
    </Suspense>
  );
}